<button [type]="isSubmitButton ? 'submit' : 'button'" [ngClass]="isPrimaryButton ? 'ep-btn ep-btn-primary save-button' : 'ep-btn ep-btn-secondary save-button'" (click)="onButtonClick()" [disabled]="disabled">
  <span *ngIf="loading" class="fa fa-circle-o-notch fa-spin spinner"> </span>
  {{ label }}
</button>
